define('app/sds/attribute/edit/sds-attribute-edit',["$timeout", "filter!date"], function ($timeout, dateFilter) {
	return {
		model: {
			"type": "&",
			"ngModel": "=",
		},
		controller: {
			prototype: {
				format: "shortDate",
				open: function($event) {
					$event.preventDefault();
					$event.stopPropagation();

					this.opened = true;
				}
			},
			properties: {
				normalizedType: function () {
					var type = this.type() || "";
					switch (type.toLowerCase()) {
						case "bool":
						case "boolean":
							return "bool";
						case "list":
						case "stringlist":
						case "select":
							return "select";
						case "int":
						case "integer":
							return "int";
						case "string":
						case "text":
							return "text";
						default:
							return type.toLowerCase();
					}
				},
				model: function() {
					return this.ngModel || {};
				},
				value: {
					get: function () {
						switch (this.normalizedType) {
							// For a select the value apparently needs to be a string for it to work.
							case "select":
								return this.model.value + "";
								break;
							case "bool":
								return this.model.value;
								break;
							case "datetime":
								return dateFilter(this.model.value, this.format);
								break;
							default:
								return this.model.value;
								break;
						}
					},
					set: function (value) {
						return this.model.value = value;
					}
				}
			}
		}
	};
});
